const rankingData = [
  { rank: 1, title: '流浪地球3', hot: '9.8', tag: '科幻巨制', desc: '人类命运终极决战，视觉奇观再升级', change: 'up' },
  { rank: 2, title: '封神第二部', hot: '9.6', tag: '神话史诗', desc: '武王伐纣大战一触即发', change: 'up' },
  { rank: 3, title: '热辣滚烫', hot: '9.5', tag: '励志喜剧', desc: '这个夏天最燃的蜕变故事', change: 'new' },
  { rank: 4, title: '飞驰人生3', hot: '9.3', tag: '赛车动作', desc: '巴音布鲁克最后的弯道之王', change: 'up' },
  { rank: 5, title: '孤注一掷2', hot: '9.1', tag: '犯罪悬疑', desc: '境外诈骗黑幕再度升级', change: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">热播排行榜</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">实时更新的热门电影榜单，发现大家都在看什么</p>

        <div className="space-y-3">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-5 p-3 md:p-4 rounded-xl bg-background-100 border border-background-200/40 hover:border-primary-500/20 transition-colors group cursor-pointer"
            >
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-background-200 font-heading font-bold text-sm md:text-base text-foreground-200">
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-50 group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-500/15 text-accent-400 whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.change === 'new' && (
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-500/15 text-primary-400 whitespace-nowrap">
                      NEW
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-1">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1.5">
                <span className="text-sm font-bold text-accent-400">{item.hot}</span>
                <span className="text-[10px] text-foreground-500">分</span>
                {item.change === 'up' && (
                  <i className="ri-arrow-up-line text-accent-400 text-xs"></i>
                )}
                {item.change === 'down' && (
                  <i className="ri-arrow-down-line text-foreground-500 text-xs"></i>
                )}
              </div>

              <div className="flex-shrink-0 hidden sm:block">
                <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-primary-500/10 text-primary-400 text-xs font-medium group-hover:bg-primary-500 group-hover:text-background-950 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-play-fill text-sm"></i>
                  播放
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}